import React, { createContext, useContext, useMemo, ReactNode } from 'react';
import { Connection } from '@solana/web3.js';

interface ConnectionContextState {
  connection: Connection;
}

const ConnectionContext = createContext<ConnectionContextState | undefined>(undefined);

interface ConnectionProviderProps {
  endpoint: string;
  children: ReactNode;
}

export const ConnectionProvider: React.FC<ConnectionProviderProps> = ({ endpoint, children }) => {
  const connection = useMemo(() => new Connection(endpoint, 'confirmed'), [endpoint]);

  const value = useMemo(() => ({ connection }), [connection]);

  return (
    <ConnectionContext.Provider value={value}>
      {children}
    </ConnectionContext.Provider>
  );
};

export const useConnection = (): ConnectionContextState => {
  const context = useContext(ConnectionContext);
  if (!context) {
    throw new Error('useConnection must be used within a ConnectionProvider');
  }
  return context;
};
